<div class="inline-edit-input" [class.large]="isLarge" [class.control-like]="controlLike">
  @if (label) {
    <div class="header">
      <div class="label">{{ label }}</div>
    </div>
  }
  @if (!editMode) {
    <div class="content"><ng-content/></div>

    <button
      type="button"
      class="btn btn-secondary btn-icon edit-btn"
      [disabled]="loading"
      (click)="edit()"
    >
      <i class="icon ic-edit-20"></i>
    </button>
  } @else {
    <input
      type="text"
      class="input"
      [class.loading]="loading"
      [disabled]="loading"
      (keyup.enter)="save()"
      [(ngModel)]="inputValue"
    >
    @if (!loading) {

      <button
        type="button"
        class="btn btn-icon save-btn"
        [class]="{
             'btn-secondary': controlLike,
             'btn-primary': !controlLike,
           }"
        [disabled]="loading"
        (click)="save()"
      >
        <i
          class="icon"
          [class]="{
             'ic-checkmark-circle-20': controlLike,
             'ic-checkmark-20': !controlLike,
           }"
        ></i>
      </button>

      <button
        type="button"
        class="btn btn-secondary btn-icon close-btn"
        [disabled]="loading"
        (click)="cancel()"
      >
        <i
          class="icon"
          [class]="{
             'ic-cancel-circle-20': controlLike,
             'ic-close-20': !controlLike,
           }"
        ></i>
      </button>
    } @else {
      <i class="fad fa-spinner-third fa-spin ml-n3"></i>
    }
  }
</div>
